import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Workplace.css";
import { ViewContainer } from "./../../View.jsx";
import { WorkplaceForm } from './WorkplaceForm';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";
import { v4 as uuidv4 } from "uuid";


const formRef = React.createRef();
const utils = new ViewUtils();

const toolbarRef = React.createRef();
class Workplace extends Component {



    constructor(props) {
        super(props);
        this.state = {
            workplaceDetails: {
                CompanyName: null
            },
            title: "",
            id: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection)) ? this.props.location.state.selection : null,
            NewRecordGUID: uuidv4(),
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' },
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: this.props.menuPermissionItem.Edit },
                    ]
                }
            ]
        };
    }



    handleFormValueChange = (values) => {
        if (!utils.isNull(values)) {
            this.setState({
                workplaceDetails: {
                    CompanyName: values.CompanyName
                }
            });
        }
        }
    

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.closeView();
        }
    }


    successCallback = () => {

        this.setState({ message: "Workplace updated successfully", messageStyle: "SUCCESS" });
    }


    save() {

        let formValue = formRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            let isAdd = true;
            if (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection)) {
                formValue.id = this.props.location.state.selection;
                isAdd = false;
            }
            formValue.WorkplaceGUID = this.state.NewRecordGUID;
            formValue.Document = this.state.Document;
            const data = JSON.stringify(formValue);
            let url = "api/sims/workplacedetails/updateworkplace";
            if (!isAdd) {
                utils.invokeUrl(url, (response) => {
                    utils.showMessage(this, response.Message, response.MessageType);
                    this.successCallback(response)
                },
                    null,
                    {
                        method: 'PUT',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },
                        body: data
                    }
                )
            } else {
                url = "api/sims/workplacedetails/insertworkplace";
                utils.invokeUrl(url, (response) => {
                    utils.showMessage(this, response.Message, response.MessageType);
                    this.successCallback(response)
                },
                    null,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },
                        body: data
                    }
                )
            }
        }
    }
    
    closeView() {
        this.props.history.push('/workplaceSearch');
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {"Workplace " + (this.state.workplaceDetails.CompanyName !== null ? "> " + this.state.workplaceDetails.CompanyName : "> Add")}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    ref={toolbarRef}
                                    title="Workplace"
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer" style={{maxHeight: "60vh"}}>
                                <WorkplaceForm ref={formRef} id={typeof this.props.location.state !== 'undefined' ? this.props.location.state.selection : null}
                                    valueChangeHandler={(values) => this.handleFormValueChange(values)} editPermission={this.props.menuPermissionItem.Edit} viewOnly={this.props.location.state.viewOnly} NewRecordGUID={this.state.NewRecordGUID} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(Workplace));
